import * as React from "react";
import {cx}       from "emotion";

import "./folder-nav.scss";

import {Link,
        makeChain} from "@Common/react/cst2";
import {Types}     from "@Common/types";
import {Select}    from "@Common/ui-components/heavy/common/design2/select/select";


export const FolderNav = ({
    folderId,
    folders,
    displayAsDropDown  = false,
    onSelect
}:{
    folderId           : number
    folders            : Types.Apis.Models.GalleryFolderProperty[],
    displayAsDropDown ?: boolean
    onSelect           : (folderId : number) => void
}) => (

    makeChain<JSX.Element>()

    // return a drop-down if requesting the drop-down format
    .then((_, next:Link<JSX.Element, void>) => {
        if (!displayAsDropDown) return next();

        let items = [];
        for (const folder of folders) {

            // don't display empty folders (unless contains subfolders that aren't empty)
            if (!folder.numImages && !folder.subFolders.find(x => x.numImages > 0)) continue;

            items.push({
                id: folder.id,
                name: folder.name,
                display: <div className="folder">
                    <i className="fa fa-folder-open"></i>
                    <span>{folder.name}</span>
                </div>,
            });

            for (const subFolder of folder.subFolders) {
                if (!subFolder.numImages) continue;
                items.push({
                    id: subFolder.id,
                    name: subFolder.name,
                    display: <div className="subfolder">
                        <i className="fa fa-chevron-right"></i>
                        <span>{subFolder.name}</span>
                    </div>,
                });
            }

        }

        return <div className="folder-nav-p5s">
            <Select
                list={items}
                itemToLabel={v => v.display}
                isSelected={v => v.id === folderId}
                onChange={v => onSelect(v.id)}
                captureOutsideClicks={true}
                xdQaName="Folder"
            />
        </div>;

    })

    // create the base JSX structure, setting folder for each folder or subfolder
    .then("folder", (_, next:Link<JSX.Element>) => (
        <ul className="folder-nav-p5s">
            {folders?.filter(x => x.numImages > 0 || x.subFolders.find(y => y.numImages > 0)).map(folder =>
                <React.Fragment key={"list-fragment-"+folder.id}>
                    {next(folder)}
                    {folder.subFolders
                        && (folder.id === folderId || folder.subFolders.find(x => x.id === folderId))
                        && folder.subFolders.filter(x => x.numImages > 0).map(subFolder => next(subFolder))
                    }
                </React.Fragment>
            )}
        </ul>
    ))

    // check if the folder is a subfolder
    .then("isSubfolder", ({folder}, next:Link<JSX.Element, boolean>) => next(!folder.hasOwnProperty("subFolders")))

    // check if the folder is selected or if the parent folder contains the selected folder
    .then("isSelected", ({folder}, next:Link<JSX.Element, boolean>) => next(folder.id === folderId || folder.subFolders?.find(x => x.id === folderId)))

    // create the line item for each folder
    .then(({folder, isSubfolder, isSelected}) => (
        <li xd-qa-type="link" xd-qa-name={folder.name}
            key={folder.id}
            className={cx(
                (!isSubfolder) ? "folder" : "subfolder",
                folder.id===folderId && "active",
                !isSubfolder && isSelected && "open",
            )}
            // if there are images in the folder, select the folder - if no images, enter the first subfolder
            onClick={() => onSelect(folder.numImages > 0 ? folder.id : folder.subFolders[0].id)}
        >
            <i className={cx("fa", (isSelected) ? "fa-chevron-down" : "fa-chevron-right")}></i>
            {!isSubfolder && (<i className={cx("fa", (isSelected) ? "fa-folder-open" : "fa-folder", "folder")}></i>)}
            <span>{folder.name}</span>
        </li>
    ))

    .run()

);
